import { createSlice } from "@reduxjs/toolkit";
import { isPlainObject } from "lodash";

const initialState = {
  id: null,
  name: null,
  userCount: null,
  dateCreated: null,
  isDisabled: null,
  // Tab to land on when the company view opens (null = default tab)
  activeTab: null,
  // Optional params for that tab (e.g. { companyRoleIds: [1] } to prefilter Users)
  activeTabParams: null,
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanyDetails: (state, action) => {
      return { ...state, ...action.payload };
    },
    // Payload: a tab name, or { tab, params }, or null to reset
    setCompanyActiveTab: (state, action) => {
      const { payload } = action;
      const isObjectPayload = isPlainObject(payload);
      return {
        ...state,
        activeTab: (isObjectPayload ? payload.tab : payload) || null,
        activeTabParams: (isObjectPayload ? payload.params : null) || null,
      };
    },
    clearCompanyActiveTabParams: state => {
      return { ...state, activeTabParams: null };
    },
    clearCompanyDetails: () => {
      return initialState;
    },
  },
});

export const {
  setCompanyDetails,
  setCompanyActiveTab,
  clearCompanyActiveTabParams,
  clearCompanyDetails,
} = companySlice.actions;

// Selectors
export const getCompanyDetails = state => state.company;

// Tab the company view should open on
export const getCompanyActiveTab = state => state.company?.activeTab || null;

// Params for the tab the company view should open on
export const getCompanyActiveTabParams = state => state.company?.activeTabParams || null;

// Helper function to get company ID
export const getCompanyId = state => state.company?.id || null;

export default companySlice.reducer;
